document.addEventListener("DOMContentLoaded", function(event) {
    if (window.location.hash) {
        let hash = window.location.hash;
        if (hash==='#refund'){
            let refund = jQuery(hash);
            jQuery('html,body').stop(true, false).animate({
                scrollTop:refund.offset().top
            }, 500);
        }
    }
    if (document.querySelector('.tab-nav')){
        let path = location.pathname; 
        let anchor = document.querySelectorAll('.tab-nav a');
        anchor.forEach((el)=>{
            if(el.pathname.includes(path)) {
                el.parentElement.classList.add('active')
            };
        });
    }
});

jQuery(document).ready(function($){
    var relatedSelect = $('#related_select');
    if (relatedSelect.length>0) {
        var elems = document.querySelectorAll('tbody tr td[data-label="Miasto"]');
        var arr = Array.from(elems,x => x.textContent);
        arr = Array.from(new Set(arr));
        var sel = document.querySelector('select[name="city"]');
        var option;

        arr.forEach(function(element,key){
            option = new Option(element,element);
            sel.add(option);
        });
        sel.addEventListener('change', (event) => {
            if(event.target.value=='Miasto'){
                jQuery('#related_table tbody tr').show();
            }else{
                jQuery('#related_table tbody tr').hide().has('td[data-label="Miasto"]:contains('+event.target.value+')').show();
            }
        });
    }
});